// extracted by mini-css-extract-plugin
export var card = "_mo-0";
export var content = "_mo-2";
export var details = "_mo-3";
export var icon = "_mo-1";
export var iconBlue = "_mo-5";
export var iconBrand = "_mo-4";
export var iconGrayBlue = "_mo-6";
export var iconGreen = "_mo-7";
export var iconIndigo = "_mo-8";
export var iconOrange = "_mo-9";
export var iconPurple = "_mo-a";
export var iconRed = "_mo-b";
export var iconWarning = "_mo-c";